module.exports = __webpack_public_path__ + "static/media/email-password.321a9f0f.svg";